<template>
  <div class="st-top-banner">
    <div class="flex-1 flex items-center order-2 lg:order-1">
      <div v-if="getTagline">
        <h1 class="st-top-banner__title">
          {{ getTagline.title }}
        </h1>
        <p class="st-top-banner__subtitle">
          {{ getTagline.content }}
        </p>
        <div class="st-top-banner__action">
          <CommonContinueRegistration>
            <template #else>
              <CommonEmailInputButton
                flat
              />
            </template>
          </CommonContinueRegistration>
        </div>
      </div>
    </div>
    <div class="flex-1 order-1 lg:order-2 mb-6 lg:mb-0">
      <BaseImg
        class="mb-2 w-full"
        src="/front-img/start-teaching/top-banner-1.webp"
        :sizes="{lg: ['588','248'], xs: ['328','173']}"
        preload
      />
      <div class="flex justify-between space-x-2">
        <BaseImg
          class="flex-1 max-w-full"
          src="/front-img/start-teaching/top-banner-2.webp"
          :sizes="{lg: ['278','176'], xs: ['160','105']}"
        />
        <BaseImg
          class="flex-1 max-w-full"
          src="/front-img/start-teaching/top-banner-3.webp"
          :sizes="{lg: ['278','176'], xs: ['160','105']}"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import staticData from './static-data'
import CommonEmailInputButton from '~/components/common/email-input-button'
import CommonContinueRegistration from '~/components/common/continue-registration.vue'
export default {
  name: 'StartTeachingTopBanner',
  components: {
    CommonContinueRegistration,
    CommonEmailInputButton
  },
  data () {
    return {
      email: '',
      loading: false,
      ...staticData
    }
  },
  computed: {
    ...mapGetters('local', ['getStepStatus', 'getRouteNameSteps', 'getTagline'])
  }
}
</script>
<style lang="scss">
.st-top-banner {
  @apply container flex flex-col lg:flex-row lg:justify-between
  lg:space-x-14;
  &__title {
    @apply text__headline-3-xs--bold lg:text__headline-2-md--bold mb-4 text-title w-[65%] lg:w-full
    text-center lg:text-left mx-auto;
  }
  &__subtitle {
    @apply text__caption-xs--regular lg:text__body-2-md--regular mb-4 lg:mb-14 text-body-2;
  }
  &__action {

  }
}
</style>
